import React from "react";
import styled from "styled-components";
import Ripples from "react-ripples";

const FixedWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  background: #00000066;

  .logout-confirmation {
    width: 540px;
    background: #ffffff;
    border-radius: 12px;
    padding: 48px 72px;
    max-height: 90vh;
    overflow-y: auto;
  }

  @media (max-width: 767px) {
    .logout-confirmation {
      width: calc(100vw - 32px);
      padding: 24px 20px;
    }
  }

  .logout-cancel-button {
    border: 1px solid #6b7280;
    border-radius: 8px;
    cursor: pointer;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logout-cancel-button:hover {
    border: 1px solid #ffffff;
    background: #d6d6d6;
  }

  .logout-button {
    border: 1px solid #0061ff;
    border-radius: 8px;
    cursor: pointer;
    background-color: #0061ff;
    color: white;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logout-button:hover {
    border: 1px solid #0061ffcc;
    background: #0061ffcc;
  }

  .preview-img {
    max-height: 120px;
    max-width: 120px;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #e5e7eb;
  }
`;

const HttpConfirmation = ({ yesFunc, data, noFunc }) => {
  if (!data?.attributes || data.attributes.length === 0) {
    return null;
  }

  const mappedChanges = data.attributes.map((data, index) => {
    if (!data.value?.new) return null;

    const isImageChange =
      data.field.toLowerCase().includes("зураг") ||
      /\.(jpeg|jpg|png|gif|webp)$/i.test(data.value.new);

    return (
      <div className="flex flex-col py-2" key={index}>
        <div className="flex flex-row">
          <h5 className="font-medium">{data.field}:</h5>
        </div>

        {isImageChange ? (
          <div className="relative flex flex-row gap-4 pt-2">
            <div className="w-1/2 text-left">
              <h5 className="text-sm pb-1">Хуучин:</h5>
              {data.value.old ? (
                <img
                  src={data.value.old}
                  alt="Old"
                  className="preview-img w-full"
                />
              ) : (
                <div className="w-full bg-gray-100 flex items-center justify-start">
                  <span>Зураг байхгүй</span>
                </div>
              )}
            </div>
            <div className="w-1/2 text-left">
              <h5 className="text-sm pb-1">Шинэ:</h5>
              <img
                src={data.value.new}
                alt="New"
                className="preview-img w-full"
              />
            </div>
            <div className="absolute w-full h-full bg-black opacity-0"></div>
          </div>
        ) : (
          <div className="flex flex-col sm:flex-row break-words gap-1 sm:gap-2">
            <div className="w-full sm:w-1/2 text-left">
              <h5>Хуучин: {data.value.old}</h5>
            </div>
            <div className="w-full sm:w-1/2 text-left">
              <h5>
                Шинэ: <b>{data.value.new}</b>
              </h5>
            </div>
          </div>
        )}
      </div>
    );
  });

  return (
    <FixedWrapper>
      <div className="flex flex-col items-center justify-center w-full h-full">
        <div
          className="logout-confirmation"
          onClick={(e) => e.stopPropagation()}
        >
          <h5 className="font-medium text-center pb-4 text-xl md:text-2xl">
            Та хүсэлт явуулахдаа итгэлтэй байна уу?
          </h5>
          <h5 className="text-base md:text-lg font-semibold text-center">Өөрчлөлтүүд:</h5>
          {mappedChanges}
          <div className="flex flex-row gap-4 md:gap-8 justify-around pt-6">
            <Ripples
              color="#FFFFFF40"
              during={600}
              className="w-full h-full rounded-lg"
            >
              <div
                className="logout-button"
                onClick={() => {
                  yesFunc();
                  noFunc();
                }}
              >
                <h5 className="text-sm font-medium py-2 px-4">Тийм</h5>
              </div>
            </Ripples>
            <Ripples
              color="#0061FF40"
              during={600}
              className="w-full h-full rounded-lg"
            >
              <div className="logout-cancel-button" onClick={() => noFunc()}>
                <h5 className="text-sm font-medium py-2 px-4">Үгүй</h5>
              </div>
            </Ripples>
          </div>
        </div>
      </div>
    </FixedWrapper>
  );
};

export default HttpConfirmation;
